// src/DatabaseAdmin/TableRow.jsx
import PropTypes from 'prop-types';
import styles from './TableRow.module.scss';

const TableRow = ({ row, selectedTable, isSelected, onSelect, onEdit }) => {
  return (
    <tr className={`${styles.row_DatabaseAdmin} ${isSelected ? styles.selected_DatabaseAdmin : ''}`} onClick={onSelect}>
      <td>{row.id}</td>
      {selectedTable === 'Регионы' ? (
        <>
          <td>{row.city}</td>
          <td>{row.region}</td>
        </>
      ) : selectedTable === 'Паблики' ? (
        <>
          <td>{row.title}</td>
          <td>{row.group_id}</td>
          <td>{row.region_id}</td>
        </>
      ) : (
        <>
          <td>{row.name}</td>
          {selectedTable === 'Community' && <td>{row.group_id}</td>}
        </>
      )}
      <td>
        <button className={styles.editButton_DatabaseAdmin} onClick={onEdit}>
          ✏️
        </button>
      </td>
    </tr>
  );
};

TableRow.propTypes = {
  row: PropTypes.object.isRequired,
  selectedTable: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

export default TableRow;